import axios from 'axios'
import { useState } from 'react'
import { apiStatus } from '../constants/apiStatus'
import { apiUrl, axiosDefaultHeader } from '../constants/apiUrl'
import { loadStatus } from '../constants/loadStatus'
import { errorMsg } from '../constants/messages'
import type { ResultIllustrationAddInfo } from '../interfaces/IllustrationIf'
import { useAuth } from './useAuth'
import { useApiUrl } from './useApiUrl'

interface C502IllustrationAddProps {
  execIllustrationAdd: (
    deviceId: string,
    illustration_name: string,
    file_body: File,
    signed_url: string,
    opts?: { overwrite?: boolean },
  ) => Promise<ResultIllustrationAddInfo>
  loading: loadStatus
}
// C502 図解登録API呼出
export const useC502IllustrationAdd = (): C502IllustrationAddProps => {
  const [loading, setLoading] = useState(loadStatus.NONE)
  const auth = useAuth()
  const { buildDeviceUrl } = useApiUrl()
  const execIllustrationAdd = async (
    deviceId: string,
    illustration_name: string,
    file_body: File,
    signed_url: string,
    opts?: { overwrite?: boolean },
  ) => {
    try {
      setLoading(loadStatus.LOADING)
      const jwt = await auth.getJwt()
      if (jwt === '') {
        setLoading(loadStatus.LOADED)
        return { success: false, message: errorMsg.SESSION_ERROR }
      }
      // ヘッダ作成
      const header = Object.assign(axiosDefaultHeader, {
        Authorization: 'Bearer ' + jwt,
      })
      // console.log(header);

      // ボディ作成
      const body = {
        illustration_name: illustration_name,
        language: 'ja',
        file_name: file_body.name,
        url: signed_url,
        overwrite: opts?.overwrite === true,
      }
      // console.log(body);

      const response = await axios.post(
        buildDeviceUrl(deviceId, apiUrl.illustrationsPath),
        body,
        {
          headers: header,
          validateStatus: () => true,
        },
      )

      if (response.status === apiStatus.SUCCESS) {
        setLoading(loadStatus.LOADED)
        return { success: true, info: response.data }
      }
      setLoading(loadStatus.LOADED)
      if (response.data && response.data.message) {
        return { success: false, message: response.data.message }
      }
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    } catch (error) {
      // console.log(error);
      setLoading(loadStatus.LOADED)
      return { success: false, message: errorMsg.SYSTEM_ERROR }
    }
  }

  return { execIllustrationAdd, loading }
}
